<div id="{{linkId}}" class="card-header">
  <div class="row">
    <div class="col-sm-10">
      @if (activityType) {
        <span class="content-type-label">{{activityType}}</span>
      }
      @if (sectionHeader) {
        <h1 class="mt-2">{{activityTitle}}</h1>
      }
      @if (!sectionHeader) {
        <h2 class="mt-2">{{activityTitle}}</h2>
      }
    </div>
    @if (activitySize || activityDifficulty || activityDuration) {
      <div class="col-sm-2 time-indicator" >
        <div class="time-container">
          <span class="icon-gecko-time text-info"></span>
          @if (activitySize) {
            <span class="text-info">Size {{activitySize}}</span>
          }
          @if (activityDifficulty) {
            <span class="text-info">Difficulty {{activityDifficulty}}</span>
          }
          @if (activityDuration) {
            <span class="text-info">{{activityDuration}}</span>
          }
        </div>
      </div>
    }
  </div>
</div>